import { 
    CreateCardCategoryDto, 
    DeleteCardCategoryDto,
    EditCardCategoryDto,
    GetCardCategoryDto, 
    MessageResponseDto, 
    UtilCardCategoryControllerGet200Response,
    UtilityCardCategoryApiFp,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseCardCategoryModel = UtilCardCategoryControllerGet200Response;
export type GetCardCategoryModel = GetCardCategoryDto;
export type MutateResponseCardCategoryModel = MessageResponseDto;
export type CreateCardCategoryModel = CreateCardCategoryDto;
export type UpdateCardCategoryModel = EditCardCategoryDto;
export type DeleteCardCategoryModel = DeleteCardCategoryDto;

export const apiCardCategoryFp =  UtilityCardCategoryApiFp(apiConfig);
export const getCardCategoryController = apiCardCategoryFp.utilCardCategoryControllerGet;
export const createCardCategoryController = apiCardCategoryFp.utilCardCategoryControllerCreate;
export const updateCardCategoryController = apiCardCategoryFp.utilCardCategoryControllerEdit;
export const deleteCardCategoryController = apiCardCategoryFp.utilCardCategoryControllerDelete;

export const QueryKeyCardCategory = QueryKey.CardCategory;